export default Uint32Array;
